export default __webpack_public_path__ + "static/media/greentick-icon.04288bcb.svg";